import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const PMRService = {

    async getPMRReports(formData) {
        const Token = localStorage.getItem("respData");

        try {
            const response = await axios.post(`${API_URL}/MRReports/MRSitesReportsGet`, formData, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${Token}`
                },
            }, { withCredentials: true });
            console.log(formData + Token, "formData")
            const reports = Array.isArray(response.data) ? response.data : response.data.Table || [];

            return reports;
        } catch (error) {
            console.error("Error:", error.message);
            throw error;
        }
    },

    async getPMRReportsPerId(formData) {
        try {

            const response = await fetch(`${API_URL}/MRReports/MRSitesReportsGetByReportID?ReportID=` + formData.ReportID + "&UserID=" + formData.UserID, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/pdf',
                    "Authorization": `Bearer ${formData.token}`
                },
            },

            );
            const result = await response.blob();
            console.log(result, "result")
            return result;
        } catch (error) {
            console.error("Error:", error.message);
            throw error;
        }
    },
    async getPMRGridItems(formData) {
        const Token = localStorage.getItem("respData");

        try {

            const response = await fetch(`${API_URL}/MRSites/MRGroupsMstrGet?SiteID=0&Active=true&UserID=5`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${Token}`
                },
            },
                console.log(formData + Token, "formData")

            );
            const result = await response.json();
            console.log(result, "result")
            return result;
        } catch (error) {
            console.error("Error:", error.message);
            throw error;
        }
    }
    // MRSItesMstrGet: (SiteID = 0, Active = true, UserID) =>
    //     axios.get(`${API_URL}/MRSites/MRSitesMstrGet`, { params: { SiteID, Active, UserID } }),

    // MRSItesReportsGet: (formData) =>
    //     axios.post(`${API_URL}/MRReports/MRSitesReportsGet`, formData),

    // MRSitesCredentialsSave: (formData) =>
    //     axios.post(`${API_URL}/MRSitesCredentials/MRSitesCredentialsSave`, formData),

    // MRSitesFetchAttemptsSave: (formData) =>
    //     axios.post(`${API_URL}/MRSitesFetchAttempts/MRSitesFetchAttemptsSave`, formData),

    // MRSitesFetchAttemptsGet: (formData) =>
    //     axios.post(`${API_URL}/MRSitesFetchAttempts/MRSitesFetchAttemptsGet`, formData),

    // MRSitesReportsGetByReportID: (ReportID, UserID) =>
    //     axios.get(`${API_URL}/MRReports/MRSitesReportsGetByReportID`, {
    //         params: { ReportID, UserID },
    //         responseType: 'blob',
    //         observe: 'response',
    //     }),

    // MRSItesReportsUpdate: (formData) =>
    //     axios.post(`${API_URL}/MRReports/MRSitesReportsUpdate`, formData),

    // MRSItesReportsArchive: (UserID, reportId, LoginUserID) =>
    //     axios.get(`${API_URL}/MRReports/MRSItesReportsArchive`, { params: { Archivedby: UserID, ReportID: reportId, LoginUserID } }),

    // DocumentSendEmail: (formData) =>
    //     axios.post(`${API_URL}/Document/DocumentSendEmail`, formData),

    // ReportLinkGet: (UserID, reportId) =>
    //     axios.get(`${API_URL}/Document/ReportLinkGet`, { params: { UserID, ReportID: reportId } }),

    // MRGroupsMstrGet: (SiteID = 0, Active = true, UserID = 0) =>
    //     axios.get(`${API_URL}/MRSites/MRGroupsMstrGet`, { params: { SiteID, Active, UserID } }),

    // MRCategoriesMstrGet: (SiteID = 0, GroupID = 0, Active = true, UserID = 0) =>
    //     axios.get(`${API_URL}/MRSites/MRCategoriesMstrGet`, { params: { SiteID, GroupID, Active, UserID } }),

    // ReportDocumentSave: (formData) =>
    //     axios.post(`${API_URL}/Document/ReportDocumentSave`, formData, { onUploadProgress: (progressEvent) => console.log(progressEvent) }),

    // ProvidersGet: (formData) =>
    //     axios.post(`${API_URL}/Users/ProvidersGet`, formData),

    // HospitalsGet: (formData) =>
    //     axios.post(`${API_URL}/Users/HospitalsGet`, formData),

    // InternalSharedReportsFromOthers: (LoginUserID) =>
    //     axios.get(`${API_URL}/SharedReports/InternalSharedReportsFromOthers`, { params: { LoginUserID } }),

    // UsersManagementDetailsGet: (formData) =>
    //     axios.post(`${API_URL}/Admin/UsersManagementDetailsGet`, formData),

    // getGendersList: (UserID) =>
    //     axios.get(`${API_URL}/Admin/GendersListGet`, { params: { UserID } }),

    // getSubscriptionsList: (UserID) =>
    //     axios.get(`${API_URL}/Admin/SubscriptionsListGet`, { params: { UserID } }),

    // getRolesList: (UserID) =>
    //     axios.get(`${API_URL}/Admin/RolesListGet`, { params: { UserID } }),

    // chatsGet: (chatId, loginUserId) =>
    //     axios.get(`${API_URL}/AcmehealthAI/GetACMEEnquiryMessages`, { params: { chatId, loginUserId } })
};

export default PMRService;